// extracted by mini-css-extract-plugin
export default {"hello":"hello__2TNQ_","tldr":"tldr__16TUj"};